import React from 'react';
import { Icon } from 'ui';
import { ACTION } from './roles';

/*::
type Props = {
  children?: Array<React.ReactChild>,
  icon?: string,
  label?: string,
  onClick?: () => void,
  url?: string,
}
*/

/**
 * @todo Refactor the inner portion to use a <Link> component once we have that
 */
const Action = ({ children, icon, label, onClick, url } /*: Props */) => {
  if (children) {
    return children;
  }

  let iconComponent = false;
  if (icon) {
    iconComponent = <Icon className="ContentGroup-actionIcon" name={icon} />;
  }

  const sharedProps = {
    className: 'ContentGroup-action u-linkBtn',
  };

  return (
    <div className="ContentGroup-actionContainer">
      {url ? (
        <a {...sharedProps} href={url}>
          {label}
          {iconComponent}
        </a>
      ) : (
        <button {...sharedProps} onClick={onClick} type="button">
          {label}
          {iconComponent}
        </button>
      )}
    </div>
  );
};

Action.role = ACTION;

export default Action;
